export type ProjectFlag = false | null | undefined | { enabled?: boolean };

/**
 * Normalizes the inconsistent `projectFlag` payload returned by the broker configuration.
 *
 * This helper is intentionally kept outside the store and UI so the application has a single,
 * explicit rule for interpreting all backend variants (`null`, `undefined`, `false`, `{}`,
 * or `{ enabled: boolean }`) as a stable boolean.
 */
export const isProjectFlagEnabled = (projectFlag?: ProjectFlag): boolean => {
  return projectFlag !== null && typeof projectFlag === 'object' && projectFlag.enabled === true;
};
